// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"PrivacyPolicy_privacyPolicy__NhSDV","title":"PrivacyPolicy_title__DGlYd","contentTitle":"PrivacyPolicy_contentTitle__1wLUg","content":"PrivacyPolicy_content__myxBW"};